export const IMAGE_FORMATS = ['jpeg', 'png', 'webp', 'svg', 'gif', 'bmp', 'tiff', 'ico'] as const;

export type ImageFormat = (typeof IMAGE_FORMATS)[number];

export interface ConversionRoute {
  slug: string;
  from: ImageFormat;
  to: ImageFormat;
}

export interface ConvertApiResponse {
  /** Download URL for converted file */
  downloadUrl?: string;
  /** Base64 data URL alternative */
  dataUrl?: string;
  /** Raw blob served as application/octet-stream */
  blob?: Blob;
  fileName?: string;
  mimeType?: string;
}
